import { compose } from 'recompose';
import { connect } from 'react-redux';

import NumbersReceived from './NumbersReceived';
import {getReceivedNumbers} from "../../../redux/stores/profile";

export default compose(
  connect(
    state => ({
      user: state?.profile?.user,
      receivedNumbers: state?.profile?.receivedNumbers || [],
      isLoading: state?.profile?.isLoadingReceivedNumbers || false
    }),
    dispatch => ({
      getReceivedNumbers: (params) => dispatch(getReceivedNumbers(params)),
    }),
  ),
)(NumbersReceived);
